import { toRefs, computed } from 'vue';

//
var script = {
  props: {
    id: {
      type: String,
      required: true
    },
    options: Object
  },
  setup(props) {
    const {
      id
    } = toRefs(props);
    const source = computed(() => {
      return id.value.replace('podcasts.apple.com', 'embed.podcasts.apple.com');
    });
    return {
      source
    };
  }
};
export { script as default };